import React, { useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import Loading from '@components/Loading';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import ErrorIcon from '@assets/icons/errorIcon';
import C from '@assets/themes/colors';

const BackgroundFileBar:React.FC<IProps> = (props) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    var value = false;
    if (props.newFile.status === 2) {
      if (props.newFile.svg) {
        var svgFile = props.newFile.svg.toString();
        var findError = svgFile.search("This page contains the following errors");
        if (findError >=0 ) {
          value = true;
        }
      } else {
        value = true;
      }
    }
    setHasError(value);
  }, [props.newFile])

  const renderFileName = () => {
    var fileName = props.newFile.file.name.toString();
    if (fileName.length > 11)
      fileName = fileName.substr(0, 11) + "..."
    return fileName;
  }

  const renderProgressBar = () => {
    let progress = 0;
    if (props.fileProgress && props.newFile) progress = (props.fileProgress.progress / props.newFile.canvasLength) * 100;

    return (
      <>
        {
          progress === 100 ?
            <S.CheckIcon>
              {
                hasError ?
                  <ErrorIcon />
                :
                  <BlackCheckIcon />
              }
            </S.CheckIcon>
          :
            <Loading 
              id={"loading-template"}
              loadingStyle={{marginLeft: '10px'}}
              pointsColor='#75d29a'
            />
        }
      </>
    )
  }
  
  return (
    <S.Root>
        <S.FileUploadLabel>
          {renderProgressBar()}
        </S.FileUploadLabel>
    </S.Root>
  );
}

export default BackgroundFileBar;